// Featured Content "Brand Subnav" — sticky brand bar with in-page anchor
// links. A hash link resolves to the element with that id, or falls back to
// the section whose heading text slugifies to the hash, so editors can point
// links at module titles without any markup changes.

(function () {
  const bars = document.querySelectorAll<HTMLElement>('.js-brand-subnav');
  if (!bars.length) return;

  const slug = (text: string): string =>
    text
      .toLowerCase()
      .trim()
      .replace(/['’]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

  function resolveTarget(hash: string): HTMLElement | null {
    const id = decodeURIComponent(hash.replace(/^#/, ''));
    if (!id) return null;

    const byId = document.getElementById(id);
    if (byId) return byId;

    const headings = document.querySelectorAll<HTMLElement>('main h1, main h2, main h3');
    for (const heading of Array.from(headings)) {
      if (slug(heading.textContent || '') === slug(id)) {
        return heading.closest('section') || heading;
      }
    }
    return null;
  }

  bars.forEach((bar) => {
    const navLinks = Array.from(bar.querySelectorAll<HTMLAnchorElement>('.fc-brand-subnav__nav a'));

    const anchors = navLinks
      .map((link) => (link.hash ? { link, target: resolveTarget(link.hash) } : null))
      .filter((entry): entry is { link: HTMLAnchorElement; target: HTMLElement } => !!entry?.target);

    if (!anchors.length) return;

    // Native and JS scrolls both land below the sticky bar — plus the main nav
    // when it's revealed (the bar sticks below it via --nav-sticky-offset)
    const setScrollMargins = () => {
      const offset = bar.offsetHeight + 20;
      anchors.forEach(({ target }) => {
        target.style.scrollMarginTop = `calc(var(--nav-sticky-offset, 0px) + ${offset}px)`;
      });
    };
    setScrollMargins();
    window.addEventListener('resize', setScrollMargins);

    anchors.forEach(({ link, target }) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      });
    });

    let queued = false;
    const update = () => {
      queued = false;
      const threshold = bar.getBoundingClientRect().bottom + 40;
      let current: HTMLAnchorElement | null = null;
      anchors.forEach(({ link, target }) => {
        if (target.getBoundingClientRect().top <= threshold) current = link;
      });
      navLinks.forEach((link) => link.classList.toggle('is-active', link === current));
    };
    window.addEventListener(
      'scroll',
      () => {
        if (!queued) {
          queued = true;
          requestAnimationFrame(update);
        }
      },
      { passive: true }
    );
    update();
  });
})();
